import React, { FC, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgTypography } from "@intelligems/ig-theme";
import { DiscountQuantityWidget } from "@intelligems/ig-types";
import { Grid } from "@mui/material";

import {
  selectedWidget,
  setSelectedWidgetVariantSettings,
} from "../../../store/slices/widgets";
import { IconGrid, IconGridItems } from "../WidgetVariants/IconGrid";
import { QuantityWidgetIcon1 } from "../WidgetVariants/Icons/QuantityWidgetIcon1";
import { QuantityWidgetIcon4 } from "../WidgetVariants/Icons/QuantityWidgetIcon4";

interface QuantityWidgetVariantSettingsProps {
  configType: "mobile" | "desktop";
}
export const DiscountQuantityWidgetVariantSettings: FC<
  QuantityWidgetVariantSettingsProps
> = ({ configType }) => {
  const quantityWidget = useSelector(selectedWidget) as DiscountQuantityWidget;
  const dispatch = useDispatch();

  const items = useMemo<IconGridItems>(() => {
    return [
      [
        {
          icon: <QuantityWidgetIcon1 />,
          key: "quantityButtonsWidget1",
          checked:
            quantityWidget.config[configType]?.variant ===
            "quantityButtonsWidget1",
        },
        {
          icon: <QuantityWidgetIcon4 />,
          key: "quantityButtonsWidget4",
          checked:
            quantityWidget.config[configType]?.variant ===
            "quantityButtonsWidget4",
        },
      ],
    ];
  }, [quantityWidget]);

  const onIconClick = (key: string) => {
    dispatch(setSelectedWidgetVariantSettings({ key, configType }));
  };

  return (
    <Grid container direction={"column"} rowSpacing={2} item>
      <Grid item>
        <IgTypography sx={{ fontWeight: 600, fontSize: "14px" }}>
          Button Styles
        </IgTypography>
      </Grid>
      <Grid item>
        <IconGrid
          gridKey={"quantity-widget"}
          items={items}
          onClick={onIconClick}
        />
      </Grid>
    </Grid>
  );
};
